module.exports = __webpack_public_path__ + "static/media/theme-color-hint-4.4f6835df.png";